// 引入request
import request from "@/utils/request";


//轮播图
export function banner() {
    return request({
      url: '/web/open/wheelseeding/list',
      method: 'get',
  
    })
}

// 查询知识
export function owledge() {
  return request({
    url: '/web/open/queryWebKnowledge',
    method: 'get',
  })
}

// 查询探索
export function licize() {
    return request({
      url: '/web/open/queryWebExplore',
      method: 'get',
    })
}

// 查询新知
export function newFriends() {
  return request({
    url: '/web/open/queryWebNewKnowledge',
    method: 'get',
  })
}

// 获取App版本信息
export function getFileUrl (query){
	return request({
    url: '/contest/getFileUrl',
		method:'get',
    params: query
	})
}


